import { useState, useEffect } from "react";

const useWindowSize = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResizeWindow = () => setWidth(window.innerWidth);
        // subscribe to window resize event "onComponentDidMount"
        window.addEventListener("resize", handleResizeWindow);
        return () => {
            // unsubscribe "onComponentDestroy"
            window.removeEventListener("resize", handleResizeWindow);
        };
    }, []);

    return [width];
};

const useWindowHeight = () => {
    const [height, setHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResizeWindow = () => setHeight(window.innerHeight);
        // subscribe to window resize event "onComponentDidMount"
        window.addEventListener("resize", handleResizeWindow);
        return () => {
            // unsubscribe "onComponentDestroy"
            window.removeEventListener("resize", handleResizeWindow);
        };
    }, []);

    return [height];
};

export {useWindowHeight}
export default useWindowSize;
